import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import "../../assets/css/style.css"
import { useFeatureContentQuery } from '../../store/services/FeatureService'
import { useSiteContentQuery } from '../../store/services/SitesettingService'

const Feature = () => {
    const { data: site, loading: siteLoading } = useSiteContentQuery();
    const { data, laoding } = useFeatureContentQuery();
    let siteData = site?.response?.data[0];
    let featureData = data?.response?.data;
    console.log(featureData)
    return (
        <>
            {/* Header Start Here */}
            <Header />
            {/* Header End Here */}

            {/* Feature Sec Start Here */}
            <div className="feature_sec_page our_features">
                <div className="container">
                    <div className="content-wrapper">
                        <div className="heading-wrapper">
                            <div className="glowing glowing-three">
                                <span></span>
                            </div>
                            <h4>Lend Me Token</h4>
                            <h2>{siteData?.title}</h2>
                            <p>
                                {siteData?.description}
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        {featureData?.map((data) => {
                            return (
                                <div className="col-md-4" key={data?.id}>
                                    <div
                                        className={
                                            "feature-box wow animate__animated animate__bounceIn"
                                        }
                                    >
                                        <div className="icon-box">
                                            <figure>
                                                <img
                                                    src={data?.image_path}
                                                    alt="123"
                                                    className="img-fluid"
                                                />
                                            </figure>
                                        </div>
                                        <div className="txt">
                                            <h3>{data?.title}</h3>
                                            <p
                                                dangerouslySetInnerHTML={{
                                                    __html: data?.description,
                                                }}
                                            >
                                                {data?.FeatureContent}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
            {/* Feature Sec End Here */}

            {/* Footer Start Here */}
            <Footer />
            {/* Footer End Here */}
        </>
    )
}

export default Feature